import React from "react";
import { Form } from "react-bootstrap";
import { FieldValidation } from "../useCreateWizard";

interface ValidatedFormControlProps extends Omit<React.ComponentProps<typeof Form.Control>, "isInvalid" | "isValid"> {
    validation?: FieldValidation;
}

export const ValidatedFormControl: React.FC<ValidatedFormControlProps> = ({ validation, ...props }) => {
    const hasError = validation && !validation.isValid && validation.errorMessage;

    return <Form.Control {...props} isInvalid={!!hasError} />;
};
